import EditableItemFooter from './EditableItemFooter'
import OwnBookingFooter from './OwnBookingFooter'
import ReadOnlyItemFooter from './ReadOnlyItemFooter'

import TextButton from 'LuxKit/Button/TextButton'
import { useAppSelector } from 'hooks/reduxHooks'
import { getCurrentUserId } from 'selectors/accountSelectors'
import FooterWithCreateUpdateInfo from 'tripPlanner/components/TripModal/Common/FooterWithCreateUpdateInfo'
import type { FlightItem } from 'tripPlanner/types/tripItem'
import { getOrderId, isLeBookmark } from 'tripPlanner/utils'
import { buildStandaloneFlightSearchURL } from 'tripPlanner/utils/bookmark/restoreCart'
import { useIntl } from 'react-intl'

interface Props {
  item: FlightItem
}

export default function FlightSummaryModalFooter({ item }: Props) {
  const intl = useIntl()
  const orderId = getOrderId(item)
  const userId = useAppSelector(getCurrentUserId)

  const isBookedLEFlight = item.sourceType === 'LE_Flight' && orderId

  if (isBookedLEFlight && orderId) {
    if (item.createdBy === userId) {
      return <OwnBookingFooter item={item} orderId={orderId} />
    } else {
      return <ReadOnlyItemFooter item={item} />
    }
  } else if (isLeBookmark(item)) {
    const flightSearchURL = buildStandaloneFlightSearchURL(
      item.savedItemData,
    )
    return (
      <FooterWithCreateUpdateInfo item={item}>
        <TextButton
          kind="primary"
          to={flightSearchURL}
          target="_blank"
        >
          {intl.formatMessage({
            id: 'D-B0IHp0Cvo2-e_ECy_p',
            defaultMessage: 'Select flights',
            description: 'Button to select flights for a trip planner flight item',
          })}
        </TextButton>
      </FooterWithCreateUpdateInfo>
    )
  } else {
    return <EditableItemFooter item={item} />
  }
}
